// Explicit, read-only transfer from the storefront origin to the configured member origin.
(() => {
  const root = document.querySelector('[data-fp-member-import]');
  if (!root) return;
  const status = root.querySelector('[data-import-status]');
  const button = root.querySelector('[data-import-share]');
  const list = root.querySelector('[data-import-items]');
  try {
    const configured = root.dataset.memberOrigin;
    const target = new URL(configured);
    const nonce = new URLSearchParams(location.search).get('nonce');
    if (target.protocol !== 'https:' || target.origin !== configured || target.username || target.password) {
      throw new Error('Saved fabric import is not configured. Please contact the store.');
    }
    if (!window.opener || !/^[a-f0-9-]{36}$/.test(nonce || '')) {
      throw new Error('Open this page using Review & import in your account.');
    }
    let saved;
    try {
      saved = JSON.parse(localStorage.getItem('fivepoint:saved-fabrics:v1') || '[]');
    } catch {
      throw new Error('Your saved fabrics could not be read. Allow site storage and try again.');
    }
    if (!Array.isArray(saved) || saved.length > 200 || saved.some(item =>
      !item || typeof item.url !== 'string' || !/^\/products\/[a-z0-9][a-z0-9-]{0,254}$/.test(item.url) ||
      typeof item.title !== 'string' || item.title.length > 250)) {
      throw new Error('Your saved list contains invalid entries. Review the list in the store before importing.');
    }
    const items = [...new Map(saved.map(item => [item.url, {handle: item.url.slice(10), title: item.title}])).values()];
    for (const item of items) {
      const row = document.createElement('li');
      row.textContent = item.title;
      list.append(row);
    }
    status.textContent = items.length ? `${items.length} saved fabrics ready to review.` : 'No saved fabrics were found in this browser.';
    button.disabled = false;
    button.addEventListener('click', () => {
      if (!window.opener || window.opener.closed) {
        status.textContent = 'Your account window has closed. Reopen import from your account.';
        return;
      }
      window.opener.postMessage({type: 'fivepoint:saved-import', nonce, items}, target.origin);
      button.disabled = true;
      status.textContent = 'Return to your account to select and confirm the import.';
    });
  } catch (error) {
    status.textContent = error.message;
    status.setAttribute('role', 'alert');
  }
})();
